module.exports = __webpack_public_path__ + "static/media/top-login-card.9c04801c.png";